module.exports = __webpack_public_path__ + "img/azure-administrator-associate.30099df7.png";